<div [class]="layout.shell">
  <header [class]="layout.header">
    <div class="flex items-center gap-2">
      <mat-icon class="h-5! w-5! shrink-0 text-xl! leading-5! text-primary-600">gavel</mat-icon>
      <h2 class="min-w-0 flex-1 truncate text-lg! leading-5! font-semibold! text-neutral-800">{{ data.titleKey | translate }}</h2>
    </div>
    <p class="pl-7 text-sm text-neutral-500">{{ "guaranteeV2.message.decisionHint" | translate }}</p>
  </header>

  <div [class]="layout.body">
    <!-- The answer first: what may be given as grounds, and which lines move, both follow from it. -->
    <fieldset class="flex flex-col gap-1.5">
      <legend
        guaranteesLabel
        required
        class="pb-1"
      >
        {{ "guaranteeV2.label.decision" | translate }}
      </legend>
      <div class="flex flex-wrap gap-1.5">
        @for (answer of answers; track answer) {
          <button
            guaranteesToggle
            size="lg"
            type="button"
            [pressed]="decision() === answer"
            (click)="setDecision(answer)"
          >
            <mat-icon class="h-4! w-4! text-base! leading-4!">{{ decisionIcon[answer] }}</mat-icon>
            {{ decisionLabelKey[answer] | translate }}
          </button>
        }
      </div>
    </fieldset>

    <!--
    Grounds come from the list belonging to the answer given — granting, refusing and amending each
    have their own, so a wording can never be filed under an act it was not written for.
  -->
    <fieldset class="flex flex-col gap-1.5">
      <legend
        guaranteesLabel
        required
        class="pb-1"
        [missing]="!reason()"
      >
        {{ reasonLabelKey() | translate }}
      </legend>

      <guarantees-option-picker
        wrap
        maxHeight="max-h-56"
        [options]="reasonOptions()"
        [placeholder]="reasonPlaceholderKey() | translate"
        [emptyMessage]="'guaranteeV2.message.reasonNoMatch' | translate"
        [value]="reason()"
        (valueChange)="reason.set($event)"
      ></guarantees-option-picker>

      <span [class]="fieldMessage">
        @if (!reason()) {
          {{ "guaranteeV2.message.decisionReasonRequired" | translate }}
        }
      </span>
    </fieldset>

    <label class="flex flex-col gap-1">
      <span guaranteesLabel>{{ "guaranteeV2.label.decisionNote" | translate }}</span>
      <textarea
        guaranteesControl
        class="w-full resize-y"
        name="decisionNote"
        rows="2"
        autocomplete="off"
        [placeholder]="'guaranteeV2.message.decisionNotePlaceholder' | translate"
        [ngModel]="note()"
        (ngModelChange)="note.set($event)"
      ></textarea>
    </label>

    <!-- Say which lines are left out, or the count on the button reads as the count ruled on. -->
    <div class="flex flex-col gap-1 border-t border-neutral-100 pt-2">
      <span [class]="sectionLabelClass">{{ "guaranteeV2.label.decisionTargets" | translate }}</span>

      <ul class="flex max-h-40 flex-col gap-0.5 overflow-y-auto">
        @for (line of lines(); track line.id) {
          <li class="flex items-center gap-2 text-sm">
            <mat-icon
              class="h-4! w-4! shrink-0 text-base! leading-4!"
              [class]="line.included ? 'text-success-600' : 'text-neutral-300'"
              >{{ line.included ? "check_circle" : "remove_circle_outline" }}</mat-icon
            >
            <span
              class="min-w-0 flex-1 truncate"
              [class]="line.included ? 'text-neutral-700' : 'text-neutral-400 line-through'"
              [matTooltip]="line.name"
              >{{ line.name }}</span
            >
            @if (line.blockerKey) {
              <span class="shrink-0 text-xs text-neutral-400">{{ line.blockerKey | translate }}</span>
            }
          </li>
        }
      </ul>

      @if (included().length === 0) {
        <guarantees-callout
          tone="error"
          icon="block"
          >{{ "guaranteeV2.message.decisionNoTargets" | translate }}</guarantees-callout
        >
      }
    </div>
  </div>

  <footer [class]="layout.footer">
    <button
      class="inline-flex items-center rounded-full px-3 py-1.5 text-sm font-medium text-neutral-500 transition-colors duration-150 hover:bg-neutral-100 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none motion-reduce:transition-none"
      type="button"
      (click)="cancel()"
    >
      {{ "guaranteeV2.action.cancel" | translate }}
    </button>

    <button
      class="ml-auto inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-sm font-semibold text-neutral-0 transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none disabled:opacity-40 motion-reduce:transition-none"
      type="button"
      [class]="submitClass()"
      [disabled]="!canSubmit()"
      [matTooltip]="canSubmit() ? '' : ('guaranteeV2.message.decisionReasonRequired' | translate)"
      (click)="submit()"
    >
      <mat-icon class="h-3.5! w-3.5! text-sm! leading-3.5!">{{ decisionIcon[decision()] }}</mat-icon>
      {{ decisionLabelKey[decision()] | translate }}
      <span class="tabular-nums">({{ included().length }})</span>
    </button>
  </footer>
</div>
